import { render, staticRenderFns } from "./AutomationSanbox.vue?vue&type=template&id=14cf0e27&scoped=true"
import script from "./AutomationSanbox.vue?vue&type=script&lang=js"
export * from "./AutomationSanbox.vue?vue&type=script&lang=js"
import style0 from "./AutomationSanbox.vue?vue&type=style&index=0&id=14cf0e27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cf0e27",
  null
  
)

export default component.exports